import { render, staticRenderFns } from "./AreasView.vue?vue&type=template&id=00a30e9b&scoped=true"
import script from "./AreasView.vue?vue&type=script&lang=js"
export * from "./AreasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a30e9b",
  null
  
)

export default component.exports